<template>
  <div>
    <!-- Mobile View -->
    <div class="tw-block md:tw-hidden">
      <QBtn
        outline
        no-caps
        class="fast-category-mobile-button tw-py-2 tw-px-4 tw-text-black tw-text-mb-body-small"
      >
        <span class="tw-flex tw-items-center">
          <QIcon
            name="lists"
            size="20px"
            class="tw-ml-2 tw-text-dark-gray"
          />
          <span class="tw-text-black">{{ $t('global.categories') }}</span>
        </span>
        <QMenu class="fast-category-mobile-menu">
          <div class="tw-p-4">
            <QList class="tw-flex tw-flex-col tw-gap-2">
              <QItem
                v-for="(item, index) in items"
                :key="`filter-button-mobile-${index}`"
                v-close-popup
                :active="isActive(item.path)"
                clickable
                class="fast-category-mobile-item tw-min-h-0 tw-p-0"
                @click="handleTabClick(item)"
              >
                <QItemSection class="tw-min-w-0 tw-p-0">
                  <span
                    class="tw-relative tw-inline-block tw-text-mb-body-small lg:tw-text-dt-body-small"
                    :class="isActive(item.path) ? 'tw-text-primary' : 'tw-text-dark-gray'"
                  >
                    {{ item.title }}
                    <div class="fast-category-mobile-border" />
                  </span>
                </QItemSection>
              </QItem>
            </QList>
          </div>
          <div class="fast-category-mobile-bottom-bar tw-bg-primary tw-h-1 tw-rounded-lg" />
        </QMenu>
      </QBtn>
    </div>

    <!-- Desktop View -->
    <div class="tw-hidden md:tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-11 tw-gap-y-5">
      <div
        v-for="(item, index) in items"
        :key="`category-button-${item.path}`"
        class="
          fast-category-item tw-text-mb-title-5 lg:tw-text-dt-title-5 tw-text-dark-gray hover:tw-text-primary
          tw-py-1 tw-cursor-pointer tw-relative
        "
        :class="[
          activeItem?.path === item.path ? 'tw-text-primary category-active' : 'tw-text-description',
        ]"
        @click="handleTabClick(item)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  items: CategoryMenuItem[]
  fbEventName?: string
  eventName?: string
}>(), {
  items: () => [],
  fbEventName: '',
  eventName: '',
})

const { handleTabClick, activeItem, isActive } = useCategoryMenu(props)
</script>

<style lang="scss" scoped>
:deep(.fast-category-mobile-button.q-btn) {
  background: var(--theme-color-light-gray-1) !important;
  border-radius: 20px !important;
}

:deep(.fast-category-mobile-button.q-btn::before),
:deep(.fast-category-mobile-button.q-btn::after),
:deep(.fast-category-mobile-button.q-btn .q-focus-helper) {
  border-radius: 20px !important;
}

:deep(.fast-category-mobile-button.q-btn--outline::before) {
  border-color: var(--theme-color-light-gray-2) !important;
  border-radius: 20px !important;
}

.fast-category-item::after {
  content: '';
  @apply tw-absolute tw-bottom-0 tw-left-0 tw-w-0 tw-h-[2px] tw-bg-primary;
  transition: width 0.2s ease-in-out;
}

.fast-category-item:hover::after,
.fast-category-item.category-active::after {
  @apply tw-w-full;
}
</style>

<style lang="scss">
.fast-category-mobile-menu {
  min-width: calc(100vw - 32px) !important;
  margin-top: 8px !important;
}

.fast-category-mobile-border {
  @apply tw-absolute -tw-bottom-1 tw-left-0 tw-w-0 tw-h-[1px] tw-bg-primary;
  transition: width 0.2s ease-in-out;
}

.fast-category-mobile-item:hover .fast-category-mobile-border {
  @apply tw-w-full;
}
</style>
